import {Coordinate, toStringHDMS} from "ol/coordinate";

export function LatLon(input: Coordinate, HDMS: boolean = false, decimalPlaces: number = 5) : string {
    if (HDMS) {
        return toStringHDMS(input);
    }

    return `${input[1].toFixed(decimalPlaces)}, ${input[0].toFixed(decimalPlaces)}`;
}